import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AttPreviews" */ './lazyIndex'),
    { name: 'AttPreviews' }
);

export const lazyGetAttachmentPreviews: LazyAction<
    typeof lazyIndex.getPreviews,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getPreviews);
export const lazyFetchAttachmentsForConversaion: LazyAction<
    typeof lazyIndex.fetchAttachmentsForConversaion,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.fetchAttachmentsForConversaion);
export const lazyAddAttachmentPreviews: LazyAction<typeof lazyIndex.add, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.add);
export const lazyRemoveAttachmentPreviews: LazyAction<
    typeof lazyIndex.removeAttachmentPreviewsForRow,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeAttachmentPreviewsForRow);

export {
    shouldShowAttachmentPreviewsForConversation,
    shouldShowAttachmentPreviewsForItem,
} from './helpers/shouldShowAttachmentPreviews';
export { getConversationAttachmentsViewState } from './selectors/getConversationAttachmentsViewState';
export {
    AttachmentFetchStatus,
    type ConversationAttachmentsViewState,
} from './store/schema/conversationAttachmentsViewState';
